/**
 * GLOBAL lookup data sources.
 *
 * One place for reference lists that more than one form needs, so a new form
 * binds a picker to an existing function instead of adding its own endpoint +
 * local state (CLAUDE.md §14b "don't reinvent", §19.2 #10).
 *
 * Backed by `GET /api/v1/lookups/*`, which reads the global stored procedures
 * (employees → `dbo.AI_Employee_Lookup_SP`).
 */
import { api } from './client';

/** One row of the global employee / user lookup. */
export interface EmployeeLookupItem {
  /** Shared XAF Oid — the value a form persists (e.g. Samplecheckin.RecievedBy). */
  oid: string;
  /** Login name (PermissionPolicyUser.UserName). */
  userName: string;
  /** First + Last name, falling back to display name then login. */
  fullName: string;
  /** Employee e-mail address. */
  email: string;
  /** ALPACA employee code shown on the legacy lookups. */
  displayName: string;
}

/**
 * Active employees for any employee / user picker, ordered by full name.
 *
 * @param search Optional type-to-filter over name, login, e-mail or code.
 *               Omit to get the whole roster (cached server-side).
 */
export async function fetchEmployeeLookup(
  search?: string,
  signal?: AbortSignal,
): Promise<EmployeeLookupItem[]> {
  const res = await api.get<{ success: boolean; data: EmployeeLookupItem[] }>(
    '/api/v1/lookups/employees',
    { params: search ? { search } : undefined, signal },
  );
  return res.data?.data ?? [];
}
